import marked from 'marked'
import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import Player from 'components/Common/Player'
import Heading from 'components/Luxkit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const Wrapper = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const StyledPlayer = styled(Player)`
  display: inline-block;
  width: 100%;
  height: ${rem(205)};

  ${mediaQueryUp.tablet} {
    height: ${rem(385)};
  }
`

interface Props {
  videoUrl: string
  title: string
  align: 'start' | 'center' | 'end' | 'justify'
}

marked.setOptions({
  gfm: true,
  tables: true,
  sanitize: true,
  breaks: false,
  pedantic: false,
  smartLists: true,
  smartypants: false,
})

const renderer = new marked.Renderer()

export function VideoClip({ videoUrl, title, align }: Props) {
  const markedTitle = marked(title, { renderer })
  return (
    <Pane paletteType="inverse">
      <Wrapper>
        <VerticalSpacer gap={12}>
          <Heading variant="heading2" align={align} dangerouslySetInnerHTML={{ __html: markedTitle }}></Heading>
          {videoUrl && (
            <StyledPlayer
              url={videoUrl}
              />
          )}
        </VerticalSpacer>
      </Wrapper>
    </Pane>
  )
}
